'use strict';

/**
 * Shared client-side helpers for components that resolve in-page anchors from editorial config.
 * Kept intentionally small so Anchor Sub Menu and Announcement Banner use the same normalization
 * rules when they read anchor ids from data attributes or content fields.
 */

/**
 * Normalize a raw anchor reference by removing an optional leading hash and trimming whitespace.
 *
 * @param {*} rawId
 * @returns {string}
 */
function sanitizeAnchorId(rawId) {
	if (!rawId) {
		return '';
	}
	return String(rawId).replace(/^#/, '').trim();
}

/**
 * Resolve the DOM target for a configured anchor id.
 *
 * @param {*} rawId
 * @param {Document} [doc]
 * @returns {Element|null}
 */
function getAnchorTarget(rawId, doc) {
	let anchorId = sanitizeAnchorId(rawId);
	let ownerDocument = doc || document;

	if (!anchorId || !ownerDocument || !ownerDocument.getElementById) {
		return null;
	}

	return ownerDocument.getElementById(anchorId);
}

module.exports = {
	sanitizeAnchorId: sanitizeAnchorId,
	getAnchorTarget: getAnchorTarget,
};
